import * as core from '../../../../../../../core'

import { query } from './institutional-risk-assessment-survey.query'

export const RESOURCE = {
  payload: {
    alias:
      'sr.subrecipient-details.widgets.institutional-risk-assessment.survey',
    description: 'Institutional Risk Assessment Survey',
    name: 'Institutional Risk Assessment Survey',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
